import { render, staticRenderFns } from "./MarketHypeSubscribe.vue?vue&type=template&id=5e470d60&"
import script from "./MarketHypeSubscribe.vue?vue&type=script&lang=ts&"
export * from "./MarketHypeSubscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockMarketHypeSubscribe: require('/tmp/build_dc55b0b5/src/components/block/MarketHypeSubscribe.vue').default})
